import * as z from "zod";

export const getPayPalConnectionStatus = {
  name: "getPayPalConnectionStatus" as const,
  input: z.object({}),
  output: z.object({
    /** OAuth grant present: disputes sync from PayPal. */
    connected: z.boolean(),
    /** A Redo-provisioned refund-provider doc exists: returns/claims refunds. */
    refundConfigured: z.boolean(),
  }),
};
